"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(fullName) {
    var subStrings = fullName
        .trim()
        .split(" ")
        .filter(function (s) { return s.length > 0; });
    if (subStrings.length === 0) {
        return { firstName: "", lastName: "" };
    }
    if (subStrings.length === 1) {
        return { firstName: subStrings[0], lastName: "" };
    }
    var _a = __read(subStrings), firstName = _a[0], rest = _a.slice(1);
    return { firstName: firstName, lastName: rest.join(" ") };
}
exports.default = default_1;
